"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = System;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CommonContentModule = _interopRequireDefault(require("../CommonContent.module.scss"));

var _SystemModule = _interopRequireDefault(require("./System.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../inputElements/Button/Button"));

var _Checkbox = _interopRequireDefault(require("../../../../../inputElements/Checkbox/Checkbox"));

var _ListElement = _interopRequireDefault(require("../../../../../common/ListElement/ListElement"));

var _EButtonType = _interopRequireDefault(require("../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function System(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommonContentModule.default.content, _SystemModule.default.content, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SystemModule.default.settings
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SystemModule.default.setting
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, {
    color: "red",
    className: _SystemModule.default.listElement
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "lockGui"
  }, "Lock GUI"), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    id: "lockGui",
    type: "OPTION_BTN",
    className: _SystemModule.default.checkBox,
    checked: true,
    disabled: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _SystemModule.default.setting
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, {
    color: "red",
    className: _SystemModule.default.listElement
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "showTips"
  }, "Show Tips"), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    id: "showTips",
    type: "OPTION_BTN",
    className: _SystemModule.default.checkBox,
    checked: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _SystemModule.default.setting
  }, /*#__PURE__*/_react.default.createElement(_ListElement.default, {
    color: "red",
    className: _SystemModule.default.listElement
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "chatBubbles"
  }, "Chat Bubbles"), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    id: "chatBubbles",
    type: "OPTION_BTN",
    className: _SystemModule.default.checkBox,
    disabled: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _SystemModule.default.buttons
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SYS_OPTION
  }, "Char select"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.SYS_OPTION
  }, "Exit Game")));
}